export default __webpack_public_path__ + "static/media/nigel_nervous.0a432a6c.svg";